import AppLayout from '@components/layouts/appLayout';

import StoryImage from '../components/Image';
import { StoryFooter } from '../components/layout/StoryFooter';
import { StoryHeader } from '../components/layout/StoryHeader';
import { StoryWrapper } from '../components/layout/StoryWrapper';
import NavigationOverlay from '../components/NavigationOverlay';
import { useProgressDispatchContext } from '../contexts/ProgressContext';
import { StoryPageDisplay, StoryPageType } from '../enums';
import { Renderer, Tester } from '../types';

export const renderer: Renderer = ({ story, storyPage }) => {
    // upper case expected for component
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const dispatch = useProgressDispatchContext();

    return (
        <AppLayout
            hasFixedFooter
            footerHasPointerEvents={false}
            header={
                <StoryHeader withExit story={story} storyPage={storyPage} />
            }
            body={
                <StoryWrapper>
                    <NavigationOverlay
                        onPlay={() => dispatch({ type: 'RESUME' })}
                        onPause={() => dispatch({ type: 'PAUSE' })}
                    />
                    <StoryImage storyPage={storyPage} />
                </StoryWrapper>
            }
            footer={
                <StoryFooter
                    withCtas
                    storyPage={storyPage}
                    withNavigationButtons={false}
                    withVideoPlayerButtons={false}
                />
            }
        />
    );
};

export const tester: Tester = (display, storyPage) => {
    return {
        condition:
            display === StoryPageDisplay.Default &&
            storyPage.type === StoryPageType.Image &&
            !!storyPage.ctas,
        priority: 7,
    };
};

const rendererWithTester = { renderer, tester };

export default rendererWithTester;
